/*
 * Home Actions
 *
 * Actions change things in your application
 * Since this boilerplate uses a uni-directional data flow, specifically redux,
 * we have these actions which are the only way your application interacts with
 * your application state. This guarantees that your state is up to date and nobody
 * messes it up weirdly somewhere.
 *
 * To add a new Action:
 * 1) Import your constant
 * 2) Add a function like this:
 *    export function yourAction(var) {
 *        return { type: YOUR_ACTION_CONSTANT, var: var }
 *    }
 */
import axios from "axios";
import _ from "lodash";
import { toast } from "react-toastify";

import { Config } from "../../Config.js";
import { saveLocalStorage, getToken, parseJwt } from "components/Helper/Helper";

export const onVerifyResetPasswordEmail = (email) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      try {
        let response = await axios({
          method: "post",
          url: `${Config.url}user/verifyEmailNew`,
          data: {
            email: email,
          },
        });

        if (response.data && response.data.error == 0) {
          toast.success(response.data?.message, {
            position: "bottom-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          saveLocalStorage("resetEmail", email);
          resolve(true);
        } else if (response.data && response.data.message) {
          toast.success(response.data.message, {
            position: "bottom-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          reject(response.data.message);
        } else {
          toast.success("something went wrong", {
            position: "bottom-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          reject("something went wrong");
        }
      } catch (error) {
        toast.success("something went wrong", {
          position: "bottom-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        reject(error);
      }

      // value.history.push('/landing')
    });
  };
};

export const onResetPasswordSubmit = (valueObj) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      try {
        let response = await axios({
          method: "post",
          url: `${Config.url}user/resetPasswordNew`,
          data: {
            // email: valueObj.email,
            confirmPassword: valueObj.confirmPassword,
            password: valueObj.password,
            resetToken: valueObj.resetToken,
          },
        });

        if (response.data && response.data.error == 0) {
          localStorage.removeItem("resetEmail");
          resolve(true);
        } else if (response.data && response.data.message) {
          reject(response.data.message);
        } else {
          reject("something went wrong");
        }
      } catch (error) {
        reject("something went wrong");
      }
    });
  };
};

export const onValidateToken = (valueObj) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      try {
        let response = await axios({
          method: "post",
          url: `${Config.url}user/validatetokenNew`,
          data: {
            // email: valueObj.email,
            resetToken: valueObj.resetToken,
          },
        });

        if (response.data && response.data.error == 0) {
          resolve(true);
        } else if (response.data && response.data.message) {
          reject(response.data.message);
        } else {
          reject("something went wrong");
        }
      } catch (error) {
        reject("something went wrong");
      }
    });
  };
};
